module.exports = "/assets/aaf0e535b49a5e101f8a28f34c6c7188.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/hotel.svg
// module id = 3322
// module chunks = 0